import clsx from 'clsx';
import React from 'react';

import { buildCellConfigObject } from '@hooks/useDatatableColumnConfig';
import { Table, flexRender } from '@tanstack/react-table';

import { PIN_LEFT, isPinnedLeft } from '.';

interface DataTableTbodyProps<TData> extends React.HTMLAttributes<HTMLTableSectionElement> {
  classNameTbody?: string;
  classNameTd?: string;
  numColumns: number;
  Table: Table<TData>;
}

function DataTableTbody<TData>({
  classNameTbody,
  classNameTd,
  numColumns,
  Table,
}: DataTableTbodyProps<TData>) {
  return (
    <tbody className={classNameTbody}>
      {Table.getRowModel().rows?.length ? (
        Table.getRowModel().rows.map((row) => (
          <tr
            id={row.id}
            key={row.id}
            className="group"
            data-state={row.getIsSelected() && 'selected'}
          >
            {row.getVisibleCells().map((cell) => {
              const config = cell.row.original[`${cell.column.id}_config`] as string;
              let textColor: string | undefined;
              let backgroundColor: string | undefined;
              if (config) {
                const configObj = buildCellConfigObject(config);
                textColor = configObj.color as string;
                backgroundColor = configObj.backgroundColor as string;
              }
              return (
                <td
                  key={cell.id}
                  className={clsx(
                    classNameTd,
                    'border-0 border-b border-r border-solid border-b-grayscale-beige border-r-grayscale-beige bg-white px-16 py-10 text-caption-sm transition-colors group-hover:!border-b group-hover:!bg-pro-gold',
                    {
                      'border-b-0 !bg-grayscale-beige': cell.column.getIsSorted(),
                      'sticky z-10': isPinnedLeft(cell.column),
                    }
                  )}
                  style={{
                    backgroundColor: backgroundColor || undefined,
                    color: textColor || undefined,
                    left: isPinnedLeft(cell.column)
                      ? `${cell.column.getStart(PIN_LEFT)}px`
                      : undefined,
                  }}
                >
                  {flexRender(cell.column.columnDef.cell, cell.getContext())}
                </td>
              );
            })}
          </tr>
        ))
      ) : (
        <tr>
          <td colSpan={numColumns} className="p-12">
            No data
          </td>
        </tr>
      )}
    </tbody>
  );
}

export default DataTableTbody;
